import React from "react";
import { Helmet } from "react-helmet-async";

const SEO = ({ seo }) => {
  if (!seo) return null;

  return (
    <Helmet>
      <title>{seo.seo_meta_title || ""}</title>

      <meta
        name="description"
        content={seo.seo_meta_description || ""}
      />

      <meta
        name="keywords"
        content={seo.seo_meta_keywords || ""}
      />

      <meta
        name="robots"
        content={seo.seo_robots || "index,follow"}
      />

      <link
        rel="canonical"
        href={seo.seo_canonical_url || ""}
      />

      <meta
        property="og:title"
        content={seo.seo_og_title || seo.seo_meta_title}
      />

      <meta
        property="og:description"
        content={
          seo.seo_og_description ||
          seo.seo_meta_description
        }
      />

      <meta
        property="og:url"
        content={seo.seo_canonical_url || ""}
      />

      <meta
        property="og:type"
        content="website"
      />

      <meta
        name="twitter:card"
        content="summary_large_image"
      />

      <meta
        name="twitter:title"
        content={seo.seo_og_title || seo.seo_meta_title}
      />

      <meta
        name="twitter:description"
        content={
          seo.seo_og_description ||
          seo.seo_meta_description
        }
      />
    </Helmet>
  );
};

export default SEO;